var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeftSm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6662 7.00139H6.80415L8.43015 5.37539C8.61775 5.18788 8.72317 4.93353 8.72323 4.66829C8.7233 4.40305 8.61799 4.14865 8.43048 3.96105C8.24297 3.77346 7.98862 3.66803 7.72339 3.66797C7.45815 3.66791 7.20375 3.77321 7.01615 3.96072L4.62548 6.35139C4.18866 6.78941 3.94336 7.38278 3.94336 8.00139C3.94336 8.62 4.18866 9.21336 4.62548 9.65139L7.01615 12.0421C7.20375 12.2296 7.45815 12.3349 7.72339 12.3348C7.98862 12.3347 8.24297 12.2293 8.43048 12.0417C8.61799 11.8541 8.7233 11.5997 8.72323 11.3345C8.72317 11.0692 8.61775 10.8149 8.43015 10.6274L6.80415 9.00139H12.6662C12.9314 9.00139 13.1857 8.89603 13.3733 8.70849C13.5608 8.52096 13.6662 8.2666 13.6662 8.00139C13.6662 7.73617 13.5608 7.48182 13.3733 7.29428C13.1857 7.10674 12.9314 7.00139 12.6662 7.00139Z",
    fill: "#A5A5AB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftSm);
export default __webpack_public_path__ + "static/media/arrow-left-sm.d1d36be3344858e50a2dc27ec04daeef.svg";
export { ForwardRef as ReactComponent };